import SearchCatalogue from "./pages/catalogue/SearchCatalogue";

export const RoutesLocal = {
    // pages
    Presentation: { path: "/" },
    DashboardOverview: { path: "/dashboard/overview" },

    //auth
    Signin: { path: "/dashboard/sign-in" },
    Signup: { path: "/dashboard/sign-up" },
    ForgotPassword: { path: "/dashboard/forgot-password" },
    ResetPassword: { path: "/dashboard/reset-password" },
    NotFound: { path: "/dashboard/404" },
    ServerError: { path: "/dashboard/500" },
    InProgress: {path:"/dashboard/inprogress"},
    MyProfile: {path:"/dashboard/myprofile"},

    //website
    SliderPath:{ path:"/website/slider"},
    GalleryPath:{ path:"/website/gallery"},
    FlashNews:{ path:"/website/flashnews"},

        //registration
    ManageRegistration: { path: "/ManageRegistration" },
    NewRegistration: {path:"/NewRegistration"},

    //members
    MemberSearch:{path:"/members/search"},
    memberAccounts:{path:"/members/accounts"},

    //catalogue
    NewCatalogue:{path:"/catalogue/new"},
    SearchCatalogue:{path:"/catalogue/search"},

    //subscription
    AddSubscription:{path:"/subscription/Add"},
    SearchSubscription:{path:"/subscription/search"},

    //catalogue request
    PendingRequestCatalogue: { path: "/catalogue/request/pending" },
    SearchRequestCatalogue: { path: "/catalogue/request/search" },
    NewRequestCatalogue: { path: "/catalogue/request/new" },

};